import type {
  LayoutSolutionGetters,
  LayoutSolutionModule,
  LayoutSolutionMutations,
  LayoutSolutionState,
} from '@/store/types/layout-solution-state';

const initialState = (): LayoutSolutionState => {
  return {
    isActive: false,
    agencyConfiguration: null,
  };
};

const mutations: LayoutSolutionMutations = {
  setIsLayoutSolutionActive: (state, isActive) => (state.isActive = isActive),
  setAgencyConfiguration: (state, configuration) =>
    (state.agencyConfiguration = configuration || null),
};

const getters: LayoutSolutionGetters = {
  isActive: (state) => state.isActive,
};

export default {
  namespaced: true,
  state: initialState,
  mutations,
  getters,
} as LayoutSolutionModule;
